import { resolveDeactivateEndpoints } from './activationConstants';
import { SecureLicenceStore } from './SecureLicenceStore';

/** Désactivation du poste (changement de machine) via nexxus-licensing-api. */
export class DeactivateService {
  static async deactivateCurrentDevice(): Promise<{ ok: boolean; error?: string }> {
    const jwt = await SecureLicenceStore.getActivationCertificate();
    const fingerprint = await SecureLicenceStore.getDeviceFingerprint();
    if (!jwt || !fingerprint) {
      return { ok: false, error: 'Aucune activation sur ce poste.' };
    }

    for (const endpoint of resolveDeactivateEndpoints()) {
      try {
        const res = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            certificate: jwt,
            device_fingerprint: fingerprint,
          }),
          signal: AbortSignal.timeout(15_000),
        });
        if (!res.ok) continue;
        await SecureLicenceStore.clearActivation();
        return { ok: true };
      } catch {
        // endpoint suivant
      }
    }
    return { ok: false, error: 'Connexion requise pour désactiver ce poste.' };
  }
}
